export const lightTheme = {
    white: "rgb(255, 255, 255)",
    bg: "rgb(245, 245, 245)",
    bg2: "rgb(237, 237, 237)",
    bg3: "rgb(214, 214, 214)",
    text: "rgb(33, 33, 33)",
    primary: "rgb(224, 132, 209)",
};